import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=25e07518&"
import script from "./TaskComments.vue?vue&type=script&lang=ts&"
export * from "./TaskComments.vue?vue&type=script&lang=ts&"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=25e07518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports